// extracted by mini-css-extract-plugin
module.exports = {"buscador":"nav_buscador__3Zp22","logo":"nav_logo__1u3_b","links":"nav_links__1urtT","check":"nav_check__3VZae","icon":"nav_icon__1820H","line":"nav_line__tdpRs"};